/**
 * @GENERATED from Figma node 3638:52261
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PremiereDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#9B49F2"
      d="M6.936 14.95c4.219.023 6.238-2.153 6.238-5.52 0-3.208-2.064-5.43-6.35-5.43H.787v16h2.895v-5.05zm-.112-8.437c2.289 0 3.41 1.19 3.41 2.918 0 1.952-1.211 3.007-3.343 3.007H3.682V6.513zM18.186 20v-5.97c0-2.984.718-4.06 3.748-4.06h1.279V6.984h-.875c-2.424 0-3.793 1.032-4.286 3.141l-.382-3.03h-2.379V20z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PremiereDark);
export { ForwardRef as PremiereDark };
